import { z } from 'zod';
import { AlternativePaymentMethodIntegrations } from '@mews-commander/data-access';

export const alternativePaymentMethodIntegrationFormSchema = z.object({
    [AlternativePaymentMethodIntegrations.Ideal]: z.boolean(),
    [AlternativePaymentMethodIntegrations.SepaDirectDebit]: z.boolean(),
});

export type AlternativePaymentMethodIntegrationFormValues = z.infer<
    typeof alternativePaymentMethodIntegrationFormSchema
>;
